import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

const useLazyContentMetadataGet = () => {
  const createResource = useCallback(({ contentId, skip }) => {
    if (skip || !contentId) return undefined;

    return `${API_BASE_URL}/api/v3/content-document/${contentId}/metadata/`;
  }, []);

  return useLazyRestQuery(createResource);
};

export default useLazyContentMetadataGet;
